import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../../components/inputs/input/input';
import { Note } from '../../../../../../../../components/note/note';
import { Toggle } from '../../../../../../../../components/inputs/toggle/toggle';
import ListLayout from '../../../../../../../../components/layouts/list-layout/list-layout';
import { IValidationGroup } from '../../../../../../../../hooks/validation-group/validation-group-hook';
import FedexV2AddressStore from '../../../../../stores/credentials/shipping/fedex-v2/fedex-v2-address-store';

interface IProps {
    address: FedexV2AddressStore;
    modalVGroup: IValidationGroup;
}

const FedexV2RegistrationAddressStep: React.FC<IProps> = observer(({ address, modalVGroup }) => (
    <ListLayout>
        <Note body="If online verification fails, contact FedEx support then retry address validation." />
        <FormFieldLine
            required
            label="FedEx account number"
            key="accountNumber"
            note="Your 9-digit FedEx shipping account number"
        >
            <Input
                value={address.accountNumber}
                onChange={address.setAccountNumber}
                validationGroup={modalVGroup}
                required
                autoComplete="off"
            />
        </FormFieldLine>
        <FormFieldLine required label="Company / customer name" key="customerName">
            <Input
                value={address.customerName}
                onChange={address.setCustomerName}
                validationGroup={modalVGroup}
                required
            />
        </FormFieldLine>
        <FormFieldLine required label="Street address" key="street1">
            <Input
                value={address.street1}
                onChange={address.setStreet1}
                validationGroup={modalVGroup}
                required
            />
        </FormFieldLine>
        <FormFieldLine label="Street address 2" key="street2">
            <Input value={address.street2} onChange={address.setStreet2} validationGroup={modalVGroup} />
        </FormFieldLine>
        <FormFieldLine required label="City" key="city">
            <Input
                value={address.city}
                onChange={address.setCity}
                validationGroup={modalVGroup}
                required
            />
        </FormFieldLine>
        <FormFieldLine required label="State / province" key="state">
            <Input
                value={address.state}
                onChange={address.setState}
                validationGroup={modalVGroup}
                required
            />
        </FormFieldLine>
        <FormFieldLine required label="Postal code" key="postalCode">
            <Input
                value={address.postalCode}
                onChange={address.setPostalCode}
                validationGroup={modalVGroup}
                required
            />
        </FormFieldLine>
        <FormFieldLine required label="Country code" key="countryCode">
            <Input
                value={address.countryCode}
                onChange={address.setCountryCode}
                validationGroup={modalVGroup}
                required
            />
        </FormFieldLine>
        <FormFieldLine label="Residential address" key="residential">
            <Toggle label="" checked={address.residential} onChange={address.setResidential} />
        </FormFieldLine>
    </ListLayout>
));

export default FedexV2RegistrationAddressStep;
